// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-set-edit {
  padding: 1rem;
  max-width: 800px;
  margin: 0 auto;
}

.set-header-edit {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, var(--set-color, #607D8B), color-mix(in srgb, var(--set-color, #607D8B) 70%, black));
  border-radius: 16px;
  color: white;
  margin-bottom: 1rem;
}

.set-icon-large {
  font-size: 3rem;
}

.set-header-edit h1 {
  margin: 0;
  cursor: pointer;
  font-size: 1.5rem;
}

.set-header-edit h1:hover {
  text-decoration: underline;
}

.edit-name-form {
  display: flex;
  gap: 0.5rem;
  flex: 1 1;
}

.edit-name-form input {
  flex: 1 1;
  padding: 0.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1.2rem;
}

.set-stats-bar {
  display: flex;
  gap: 1.5rem;
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 12px;
  margin-bottom: 1rem;
  justify-content: center;
}

.set-stats-bar span {
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.action-buttons .btn {
  flex: 1 1;
  padding: 1rem;
  font-size: 1.1rem;
}

.items-section {
  margin-bottom: 1.5rem;
}

.items-section h2 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: #333;
}

.items-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.item-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.item-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.item-info strong {
  font-size: 1rem;
}

.item-translation {
  color: #666;
  font-size: 0.9rem;
}

.item-meta {
  color: #999;
  font-size: 0.8rem;
}

.lesson-item {
  border-left: 3px solid #2196F3;
}

.content-item {
  border-left: 3px solid #4CAF50;
}

.empty-set {
  text-align: center;
  padding: 3rem 1rem;
  color: #666;
}

.empty-set .empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-set h3 {
  margin-bottom: 0.5rem;
  color: #333;
}

.empty-set p {
  margin-bottom: 1.5rem;
}

.error-page {
  text-align: center;
  padding: 3rem;
}

.error-page h2 {
  margin-bottom: 1.5rem;
}

.custom-set-edit .btn,
.custom-set-edit button {
  text-decoration: none;
}

`, "",{"version":3,"sources":["webpack://./src/pages/CustomSetEdit.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wHAAwH;EACxH,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":[".custom-set-edit {\n  padding: 1rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.set-header-edit {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, var(--set-color, #607D8B), color-mix(in srgb, var(--set-color, #607D8B) 70%, black));\n  border-radius: 16px;\n  color: white;\n  margin-bottom: 1rem;\n}\n\n.set-icon-large {\n  font-size: 3rem;\n}\n\n.set-header-edit h1 {\n  margin: 0;\n  cursor: pointer;\n  font-size: 1.5rem;\n}\n\n.set-header-edit h1:hover {\n  text-decoration: underline;\n}\n\n.edit-name-form {\n  display: flex;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.edit-name-form input {\n  flex: 1;\n  padding: 0.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.2rem;\n}\n\n.set-stats-bar {\n  display: flex;\n  gap: 1.5rem;\n  padding: 1rem;\n  background: #f5f5f5;\n  border-radius: 12px;\n  margin-bottom: 1rem;\n  justify-content: center;\n}\n\n.set-stats-bar span {\n  font-weight: 500;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.action-buttons .btn {\n  flex: 1;\n  padding: 1rem;\n  font-size: 1.1rem;\n}\n\n.items-section {\n  margin-bottom: 1.5rem;\n}\n\n.items-section h2 {\n  font-size: 1.2rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.item-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.item-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.item-info strong {\n  font-size: 1rem;\n}\n\n.item-translation {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.item-meta {\n  color: #999;\n  font-size: 0.8rem;\n}\n\n.lesson-item {\n  border-left: 3px solid #2196F3;\n}\n\n.content-item {\n  border-left: 3px solid #4CAF50;\n}\n\n.empty-set {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #666;\n}\n\n.empty-set .empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.empty-set h3 {\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.empty-set p {\n  margin-bottom: 1.5rem;\n}\n\n.error-page {\n  text-align: center;\n  padding: 3rem;\n}\n\n.error-page h2 {\n  margin-bottom: 1.5rem;\n}\n\n.custom-set-edit .btn,\n.custom-set-edit button {\n  text-decoration: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
